import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ITableColumn, PipeObj, PipeResult } from './tabela.model';


@Component({
  selector: 'app-tabela',
  templateUrl: './tabela.component.html',
  styleUrls: ['./tabela.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabelaComponent),
      multi: true
    }
  ]
})
export class TabelaComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() columns: ITableColumn[] = [];
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  selectedItem: any;
  selectedRowIndex: number | null = null;

  onSelectChange(value: any, item: any) {
    const body = {
      value: value,
      item: item
    };
    this.ngModelChange.emit(body);
  }

  toggleAtivo(item: any) {
    item.ativo = !item.ativo;
    this.selectedItem = item;
  }

  selectRow(index: number) {
    if (this.selectedRowIndex === index) {
      this.selectedRowIndex = null;
    } else {
      this.selectedRowIndex = index;
    }
  }

  applyPipe(column: ITableColumn, value: any): PipeResult {
    return column.pipe ? column.pipe.transform(value) : value;
  }

  isPipeObj(v: PipeResult): v is PipeObj {
    return typeof v === 'object' && v !== null && 'text' in v;
  }

  constructor() {}

  ngOnInit() {}
}
